/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2UserAlertBellIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2UserAlertBellIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2UserAlertBellIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2UserAlertBellIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-1RQgYV': alignSelf,'--mt-2-1RQgYV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1RQgYV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1RQgYV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1RQgYV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1RQgYV': opacity,'--w-10-1RQgYV': typeof width === 'number' ? `${width}px` : width,'--h-11-1RQgYV': typeof height === 'number' ? `${height}px` : height,'--f-12-1RQgYV': fill,'--a-7-1RQgYV': isAnimated ? animation : "none",'--sd-8-1RQgYV': isAnimated ? strokeDashoffset : 0,'--sd-9-1RQgYV': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2UserAlertBellIcon.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2148_13861)"
 className="views-block"
>
<path
  data-testid="Tysiav2UserAlertBellIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.857 4.571a2.571 2.571 0 11-5.143 0 2.571 2.571 0 015.143 0zm-.643 7.072v-1.5a2.571 2.571 0 115.143 0v1.5a.643.643 0 110 1.286H11.43v.428a.643.643 0 01-1.286 0v-.428H8.214a.643.643 0 010-1.286zm-1.071-.696v-.804c0-.7.198-1.355.54-1.91A4.286 4.286 0 002 12.286c0 .236.192.428.429.428h4.125a1.718 1.718 0 01.589-1.767z"
 style={{'--f-12-1RQgYV': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}